import { CurrencyPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LoaderComponent } from '@shared/components/general/loader/loader.component';
import { OrderSummaryInvoice } from '@shared/interfaces';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { FieldsetModule } from 'primeng/fieldset';

@Component({
    selector: 'app-order-summary-invoice',
    standalone: true,
    imports: [LoaderComponent, TranslateModule, ButtonModule, FieldsetModule, DividerModule, CurrencyPipe],
    templateUrl: './order-summary-invoice.component.html',
    styleUrls: ['./order-summary-invoice.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderSummaryInvoiceComponent {
    readonly orderSummaryInvoice = input.required<OrderSummaryInvoice>();
    readonly fieldsetColor = input.required<'green' | 'red'>();
    readonly id = input<string>('order-summary');
    readonly hideSubmitSection = input<boolean>(false);
    readonly submitOrderEvent = output<void>();
}
